import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import BackdropLoading from './../commons/BackdropLoading';
import DialogPaymentMethod from './../dialog/DialogPaymentMethod';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

class SubscriptionViewPaymentMethod extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      loading: false,
      openDialog: false,
    };
  }

  componentDidMount () {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  change () {
    this._isMounted && this.setState({ openDialog: true });
  }

  render () {
    const { classes, className } = this.props;
    const { loading } = this.state;
    return (
      <Box className={clsx(classes.root, className && className.root)}>
        <BackdropLoading open={loading} />
        { this.renderContent() }
        { this.renderDialogs() }
      </Box>
    );
  }

  renderContent () {
    const { classes } = this.props;

    return (
      <Box className={classes.content}>
        <Box className={classes.actions}>
          <Button color="quaternary" className={classes.action} onClick={() => this._isMounted && this.setState({openDialog: true})}>Moyen de paiement</Button>
        </Box>
      </Box>
    );

  }

  renderDialogs () {
    if (this.state.openDialog) {
      return (
        <DialogPaymentMethod
            open={this.state.openDialog}
            onClose={ () => this._isMounted && this.setState({openDialog: false}) }
            id_profile={this.props.id_profile}
            onUpdated={this.props.onUpdated}
            onDeleted={this.props.onDeleted}
            onError={this.props.onError}
            canDelete={this.props.canDelete}
          />
      );
    }
    return null;
  }
}

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderBottom: `1px solid ${theme.palette.tertiary.main}`,
  },
  title: {},
  actions: {},
  action: {
    width: '100%',
  }
});

SubscriptionViewPaymentMethod.propTypes = {
  id_profile: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  canDelete: PropTypes.bool,
  onUpdated: PropTypes.func,
  onDeleted: PropTypes.func,
  onError: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(SubscriptionViewPaymentMethod);
